import { noop } from 'lodash';
import React from 'react';

export interface TournamentContextState {
  activePage: number;
  clubId: number;
  title: string;
  subTitle: string;
  isRecurrenceOpen: boolean;
  widgetId?: string;
  loading: boolean;
  error?: string;
}

export interface ContextProvider {
  state: TournamentContextState;
  setState: React.Dispatch<React.SetStateAction<TournamentContextState>>;
}

const CreateTournamentContext = React.createContext<ContextProvider>({
  state: {
    activePage: 0,
    clubId: 0,
    title: '',
    subTitle: '',
    isRecurrenceOpen: false,
    loading: false
  },
  setState: () => noop
});

export default CreateTournamentContext;
